import { render, staticRenderFns } from "./Departamentos.vue?vue&type=template&id=935d20e6"
import script from "./Departamentos.vue?vue&type=script&lang=js"
export * from "./Departamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports